module.exports = __webpack_public_path__ + "img/recepcion-bins.13948c11.png";